exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Video{\r\n    height: 40vh;\r\n    width: 100vw;\r\n}\r\n\r\n.playBtn{\r\n    position: absolute;\r\n    height: 6em;\r\n    top: calc(60% - 3em);\r\n    left: calc(50% - 3em);\r\n    transition: opacity .4s ease;\r\n    transition-delay: .15s;\r\n}\r\n\r\n.Video>video{\r\n    height: 40vh;\r\n    object-fit: cover;\r\n    filter: blur(9px);\r\n    object-fit: cover;\r\n    transform: scale(1.1);\r\n    transition: filter 0.5s;\r\n    filter: blur(0px);\r\n    width: 100vw;\r\n}\r\n\r\n@media all and (orientation:landscape) {\r\n    .Video>video{\r\n        height: 100vh;\r\n    }\r\n}", ""]);

// exports
